// extracted by mini-css-extract-plugin
module.exports = {"main":"BackgroundLogo_main__2j-KG"};